// 初始化一级菜单  这个文件之前用的过, 但现在没用了components\public\searchBox\singleBoxSearch.vue文件里面不需要了
export const mainTypeArray = [
  { name: '地理编', id: '地理' },
  { name: '生物编', id: '生物' },
  { name: '劳作编', id: '劳作' },
  { name: '日用编', id: '日用' },
  { name: '典制編', id: '典制' },
  { name: '习尚编', id: '习尚' },
  { name: '医药编', id: '医药' },
  { name: '信仰编', id: '信仰' },
  { name: '人物编', id: '人物' }
]
